module.exports = __webpack_public_path__ + "img/flipboard.51ebf72b.svg";